// List of all markdown files
// When you add a new week, add it to this list
import week202601 from './week-2026-01.md';
// import week202602 from './week-2026-02.md';

export const postFileContents = [
	week202601,
	// week202602,
	// ... add more as you create them
];
